<template>
    <div>
        <notifications
                group="user"
                position="bottom right"
                :classes="['vue-notification', type].join(' ')"
        >
        </notifications>
    </div>
</template>

<script>
    import mixinPubSub from './mixinPubSub';

    export default {
        mixins: [ mixinPubSub ],
        props: {
            message: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                type: 'success'
            };
        },
        mounted() {

            if( this.message !== '' ) {
                this.$notify({
                    group: 'user',
                    title: '',
                    text: this.message,
                });
            }

            this.onNotify(( payload ) => {
                const { title, message, type } = payload;

                this.type = type;

                switch( type ) {
                    /*case 'success' :

                    break;
                    case 'error' :
                        this.$notify({
                            group: 'user',
                            title,
                            text: message
                        });
                    break;*/


                    default :
                        this.$notify({
                            group: 'user',
                            title,
                            text: message
                        });
                    break;
                }
            });

            /*this.onNotifyBy('success', ( payload ) => {
                const { title, message } = payload;

                this.$notify({
                    group: 'user',
                    title,
                    text: message,
                });
            });

            this.onNotifyBy('error', ( payload ) => {
                const { title, message } = payload;

                this.$notify({
                    group: 'user',
                    title,
                    text: message,
                });
            });*/
        }
    }
</script>
